// Module
var code = "<el-alert v-if=\"isShowMessage\" style=\"margin-bottom:20px\" title=\"Баланс стал меньше минимального значения. Нажмите чтобы пополнить баланс\" type=\"error\" effect=\"dark\" @close=\"closeMessage\" @click.self.native=\"redirectOnLicensesPage()\"> </el-alert> ";
// Exports
module.exports = code;